module.exports = __webpack_public_path__ + "img/ico_phone-call.b59bd00e.svg";